"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var client_exports = {};
__export(client_exports, {
  HulypulseClient: () => HulypulseClient,
  escapeString: () => escapeString
});
module.exports = __toCommonJS(client_exports);
const WS_CLOSE_NORMAL = 1e3;
class HulypulseClient {
  constructor(url) {
    this.url = url;
  }
  static {
    __name(this, "HulypulseClient");
  }
  ws = null;
  closed_manually = false;
  reconnectTimeout;
  RECONNECT_INTERVAL_MS = 1e3;
  subscribes = /* @__PURE__ */ new Map();
  pingTimeout;
  pingInterval;
  PING_INTERVAL_MS = 30 * 1e3;
  PING_TIMEOUT_MS = 5 * 60 * 1e3;
  SEND_TIMEOUT_MS = 3e3;
  correlationId = 1;
  pending = /* @__PURE__ */ new Map();
  /** Matches errors from Pulse when Redis/backend TCP is dead while WS still looks open. */
  static isConnectionLikeError(err) {
    const s = err.toLowerCase();
    return s.includes("broken pipe") || s.includes("connection reset") || s.includes("connection refused") || s.includes("connection aborted") || s.includes("unexpected eof") || s.includes("io error");
  }
  async connect() {
    await new Promise((resolve, reject) => {
      const ws = new WebSocket(this.url.toString());
      this.ws = ws;
      ws.onopen = () => {
        this.resubscribe();
        this.startPing();
        resolve(void 0);
      };
      ws.onerror = (event) => {
        this.reconnect();
      };
      ws.onclose = (event) => {
        this.reconnect();
      };
      ws.onmessage = (event) => {
        try {
          if (event.data === "ping") {
            this.ws?.send("pong");
            return;
          }
          if (event.data === "pong") {
            if (this.pingTimeout !== void 0) {
              clearTimeout(this.pingTimeout);
              this.pingTimeout = void 0;
            }
            return;
          }
          const msg = JSON.parse(event.data.toString());
          if ("message" in msg) {
            for (const [key, callbacks] of this.subscribes) {
              if (msg.key.startsWith(key)) {
                callbacks.forEach((cb, index) => {
                  try {
                    const value = msg.message === "Set" && msg.value !== void 0 ? JSON.parse(msg.value) : void 0;
                    cb(msg.key, value);
                  } catch (err) {
                    console.error(`Error in callback #${index} with key "${key}":`, err);
                  }
                });
              }
            }
          } else if ("correlation" in msg) {
            const id = msg.correlation;
            if (id !== void 0 && this.pending.has(id)) {
              const pending = this.pending.get(id);
              if (pending !== void 0) {
                clearTimeout(pending.send_timeout);
                this.pending.delete(id);
                if ("error" in msg) {
                  if (typeof msg.error === "string" && HulypulseClient.isConnectionLikeError(msg.error)) {
                    console.warn("Pulse server reported connection-like error; reconnecting");
                    this.reconnect();
                  }
                  pending.reject(new Error(msg.error));
                } else {
                  pending.resolve(msg);
                }
              }
            }
          } else {
            console.warn("Unknown message format:", msg);
          }
        } catch (e) {
          console.error("Failed to parse message", e);
        }
      };
    });
  }
  resubscribe() {
    for (const [key] of this.subscribes) {
      this.send({ type: "sub", key }).catch((error) => {
        console.error(`Resubscription failed for key=${key}:`, error);
      });
    }
  }
  startPing() {
    this.stopPing();
    this.pingInterval = setInterval(() => {
      if (this.ws?.readyState === WebSocket.OPEN) {
        this.ws.send("ping");
      }
      if (this.pingTimeout !== void 0) {
        clearTimeout(this.pingTimeout);
      }
      this.pingTimeout = setTimeout(() => {
        if (this.ws?.readyState !== WebSocket.OPEN) {
          console.warn("WS-server not responding to ping, closing connection");
          clearInterval(this.pingInterval);
          this.ws?.close(WS_CLOSE_NORMAL);
        }
      }, this.PING_TIMEOUT_MS);
    }, this.PING_INTERVAL_MS);
  }
  stopPing() {
    if (this.pingInterval !== void 0) {
      clearInterval(this.pingInterval);
      this.pingInterval = void 0;
    }
    if (this.pingTimeout !== void 0) {
      clearTimeout(this.pingTimeout);
      this.pingTimeout = void 0;
    }
  }
  [Symbol.dispose]() {
    this.close();
  }
  reconnect() {
    if (this.reconnectTimeout !== void 0) {
      clearTimeout(this.reconnectTimeout);
      this.reconnectTimeout = void 0;
    }
    this.stopPing();
    if (!this.closed_manually) {
      this.reconnectTimeout = setTimeout(() => {
        void this.connect();
      }, this.RECONNECT_INTERVAL_MS);
    }
  }
  close() {
    this.closed_manually = true;
    if (this.reconnectTimeout !== void 0) {
      clearTimeout(this.reconnectTimeout);
    }
    this.reconnectTimeout = void 0;
    this.stopPing();
    this.ws?.close();
  }
  static async connect(url) {
    const client = new HulypulseClient(url);
    await client.connect();
    return client;
  }
  async info() {
    const reply = await this.send({ type: "info" });
    if (reply.error !== void 0) {
      throw new Error(reply.error);
    }
    return reply.result ?? "";
  }
  async list() {
    const reply = await this.send({ type: "list" });
    if (reply.error !== void 0) {
      throw new Error(reply.error);
    }
    return reply.result ?? "";
  }
  async subscribe(key, callback) {
    let list = this.subscribes.get(key);
    if (list === void 0) {
      list = [];
      this.subscribes.set(key, list);
    }
    if (!list.includes(callback)) {
      list.push(callback);
      if (list.length === 1) {
        void await this.send({ type: "sub", key });
      }
    }
    const prevlist = await this.send({ type: "list", key });
    if (prevlist?.error === void 0 && Array.isArray(prevlist?.result)) {
      for (const item of prevlist.result) {
        try {
          const value = item.data !== void 0 ? JSON.parse(item.data) : void 0;
          if ((item.ttl ?? item.expires_at ?? 0) <= 1 || // TODO: remove expires_at after upgrade server
          value === void 0) {
            continue;
          }
          callback(item.key, value);
        } catch (err) {
          console.error("Error in initial callback", err);
        }
      }
    }
    return async () => {
      return await this.unsubscribe(key, callback);
    };
  }
  async unsubscribe(key, callback) {
    const list = this.subscribes.get(key);
    if (list === void 0 || !list.includes(callback)) {
      return false;
    }
    const newList = list.filter((cb) => cb !== callback);
    if (newList.length === 0) {
      this.subscribes.delete(key);
      void await this.send({ type: "unsub", key });
    } else {
      this.subscribes.set(key, newList);
    }
    return true;
  }
  async put(key, data, third) {
    const message = {
      type: "put",
      key,
      data: JSON.stringify(data),
      ...typeof third === "number" ? { TTL: third } : third
    };
    void await this.send(message);
  }
  async put_full(key, data, third) {
    const message = {
      type: "put",
      key,
      data: JSON.stringify(data),
      ...typeof third === "number" ? { TTL: third } : third
    };
    const reply = await this.send(message);
    if (reply.error !== void 0) {
      throw new Error(reply.error);
    }
  }
  async get(key) {
    const reply = await this.send({ type: "get", key });
    if (reply.error !== void 0) {
      if (reply.error === "not found") {
        return void 0;
      }
      throw new Error(reply.error);
    }
    return reply.result?.data;
  }
  async get_full(key) {
    const reply = await this.send({ type: "get", key });
    if (reply.error !== void 0) {
      if (reply.error === "not found") {
        return void 0;
      }
      throw new Error(reply.error);
    }
    return {
      data: reply.result.data,
      etag: reply.result.etag,
      expiresAt: reply.result.expiresAt
    };
  }
  async delete(key, options) {
    const message = { type: "delete", key, ...options };
    const reply = await this.send(message);
    if (reply.error !== void 0) {
      if (reply.error === "not found") {
        return false;
      }
      throw new Error(reply.error);
    }
    return true;
  }
  async send(msg) {
    const id = String(this.correlationId++);
    const message = { ...msg, correlation: id.toString() };
    if (this.closed_manually) {
      if (msg.type === "unsub") {
        return;
      }
      this.closed_manually = false;
      if (this.ws?.readyState === WebSocket.CONNECTING || this.ws?.readyState === WebSocket.OPEN) {
        return;
      }
      await this.connect();
    }
    return await new Promise((resolve, reject) => {
      if (this.closed_manually || this.ws?.readyState !== WebSocket.OPEN) {
        resolve({ error: "WebSocket is not open." });
        return;
      }
      const sendTimeout = setTimeout(() => {
        const pending = this.pending.get(id);
        if (pending !== void 0) {
          pending.resolve({ error: "Timeout waiting for response" });
          this.pending.delete(id);
        }
      }, this.SEND_TIMEOUT_MS);
      this.pending.set(id, { resolve, reject, send_timeout: sendTimeout });
      this.ws.send(JSON.stringify(message));
      this.startPing();
    });
  }
}
function escapeString(str) {
  return str.replace(/[*?\[\]\\\x00-\x1F\x7F"']/g, "_");
}
__name(escapeString, "escapeString");
//# sourceMappingURL=client.js.map
